export const campaignPrefix = "campaign";
